export default __webpack_public_path__ + "static/media/05.d853ae2c.jpg";